"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplyForRefundIneligible = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var react_1 = __importDefault(require("react"));
var core_1 = require("../../../../shared/core");
var analytics_subjects_1 = require("../../analytics-subjects");
var ui_1 = require("./ui");
var ApplyForRefundIneligible = function () {
    var _a;
    var search = window.location.search;
    var reason = (0, core_1.getValueFromQueryParams)('reason', search);
    return (react_1.default.createElement(ui_tools_1.AnalyticsPage, { name: analytics_subjects_1.NOT_ELIGIBLE_FOR_REFUND, properties: (_a = { errorReason: reason }, _a[core_1.INTERNAL_EVENT_FLAG] = true, _a) },
        react_1.default.createElement(ui_1.ApplyForRefundIneligibleUI, { reasonCode: reason })));
};
exports.ApplyForRefundIneligible = ApplyForRefundIneligible;
